<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="巡检时间段" name="slot">
          <toolbar :key="'tp-toolbar-' + toolbarKey" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
          <el-table :data="users" v-loading="listLoading" style="width: 100%; margin-top: 12px;">
            <el-table-column prop="SlotName" label="名称" width="" align="center" header-align="center"></el-table-column>
            <el-table-column prop="CampusName" label="校区" width="" align="center" header-align="center"></el-table-column>
            <el-table-column label="起止时间" width="" align="center" header-align="center">
              <template slot-scope="scope">
                {{ formatTime(scope.row.StartTime) }} - {{ formatTime(scope.row.EndTime) }}
              </template>
            </el-table-column>
            <el-table-column prop="MaxRoundCount" label="最多次数" width="" align="center" header-align="center"></el-table-column>
            <el-table-column label="状态" width="" align="center" header-align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.Enabled ? 'success' : 'danger'" size="small">
                  {{ scope.row.Enabled ? '启用' : '禁用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center" header-align="center" class-name="timeslot-op-column">
              <template slot-scope="scope">
                <div class="op-cell">
                  <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination layout="total,prev,pager,next" @current-change="handleCurrentChange"
              :current-page="page" :page-size="pageSize" :total="total" style="float: right"></el-pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="巡检条件" name="settings">
          <el-form :model="settingsForm" label-width="140px" style="max-width: 560px; margin-top: 20px;">
            <el-form-item label="登记间隔（分钟）">
              <el-input-number v-model="settingsForm.IntervalMinutes" :min="1" :max="9999"></el-input-number>
              <div class="field-hint">同一班牌相邻两次登记的最短间隔</div>
            </el-form-item>
            <el-form-item label="组内覆盖率（%）">
              <el-input-number v-model="settingsForm.CoveragePercent" :min="1" :max="100"></el-input-number>
              <div class="field-hint">开启下一轮前，组内已完成上一轮登记的班牌占比</div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveSettings" :loading="settingsSaving">保存条件</el-button>
              <div class="field-hint">从第 2 次起须同时满足间隔与覆盖率</div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="480px" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm">
          <el-form-item label="名称" prop="SlotName">
            <el-input v-model="editForm.SlotName" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="校区">
            <el-select v-model="editForm.CampusId" style="width: 100%">
              <el-option label="全校通用" :value="0"></el-option>
              <el-option v-for="item in campusOptions" :key="item.Id || item.id"
                :label="item.Name || item.name" :value="item.Id != null ? item.Id : item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" prop="StartTime">
            <el-time-picker v-model="editForm.StartTime" value-format="HH:mm:ss" format="HH:mm:ss" style="width: 100%"></el-time-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="EndTime">
            <el-time-picker v-model="editForm.EndTime" value-format="HH:mm:ss" format="HH:mm:ss" style="width: 100%"></el-time-picker>
          </el-form-item>
          <el-form-item label="最多次数" prop="MaxRoundCount">
            <el-input-number v-model="editForm.MaxRoundCount" :min="1" :max="9"></el-input-number>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="editForm.SortOrder" :min="0" :max="9999"></el-input-number>
          </el-form-item>
          <el-form-item label="启用">
            <el-switch v-model="editForm.Enabled"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click="editSubmit" :loading="editLoading">确定</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import {
  getTeacherPatrolTimeSlotListPage,
  addTeacherPatrolTimeSlot,
  editTeacherPatrolTimeSlot,
  deleteTeacherPatrolTimeSlot,
  getTeacherPatrolSettings,
  saveTeacherPatrolSettings,
  loadTeacherPatrolCampusOptions,
  clearTeacherPatrolListTable,
  onTeacherPatrolSchoolChange,
  resolveTeacherPatrolSchoolIdFromTreeNode,
  getTeacherPatrolCurrentSchoolId
} from "@/api/teacherPatrol";
import { toDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      activeTab: "slot",
      filters: { campusId: null },
      searchList: [
        { label: "校区", key: "campusId", type: "select", clearable: true, options: [] }
      ],
      buttonList: [],
      users: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      DepartmentId: 0,
      toolbarKey: 0,
      schoolId: 0,
      campusOptions: [],
      editFormVisible: false,
      editLoading: false,
      dialogTitle: "新增时间段",
      editForm: {
        Id: 0,
        SchoolId: 0,
        CampusId: 0,
        SlotName: "",
        StartTime: "12:00:00",
        EndTime: "13:00:00",
        MaxRoundCount: 6,
        SortOrder: 0,
        Enabled: true
      },
      editFormRules: {
        SlotName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        MaxRoundCount: [{ required: true, message: "请设置次数", trigger: "change" }]
      },
      settingsForm: {
        SchoolId: 0,
        CampusId: 0,
        IntervalMinutes: 15,
        CoveragePercent: 100
      },
      settingsSaving: false
    };
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
  methods: {
    formatTime(val) {
      if (!val) return "";
      if (typeof val === "string") return val.substring(0, 8);
      return val;
    },
    callFunction(item) {
      if (typeof item.search === "object") {
        this.filters = item.search;
      }
      this[item.Func].apply(this, item);
    },
    async treeNodeClick(data, node) {
      const nodeId = treeNodeDeptId(data);
      onTeacherPatrolSchoolChange(this, nodeId);
      this.schoolId = resolveTeacherPatrolSchoolIdFromTreeNode(node, nodeId);
      this.editFormVisible = false;
      await this.loadCampusOptions();
      this.handleQuery();
      this.loadSettings();
    },
    async loadCampusOptions() {
      await loadTeacherPatrolCampusOptions(this, this.DepartmentId);
    },
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    async getList() {
      if (!this.DepartmentId) {
        clearTeacherPatrolListTable(this);
        return;
      }
      this.listLoading = true;
      try {
        const res = await getTeacherPatrolTimeSlotListPage({
          departmentId: this.DepartmentId,
          campusId: this.filters.campusId || 0,
          page: this.page,
          intPageSize: this.pageSize
        });
        if (res.data.success) {
          this.users = res.data.response.data || [];
          this.total = res.data.response.dataCount || 0;
          if (this.users.length > 0) {
            this.schoolId = this.users[0].SchoolId;
          }
        } else {
          clearTeacherPatrolListTable(this);
        }
      } finally {
        this.listLoading = false;
      }
    },
    handleAdd() {
      if (!this.DepartmentId) {
        this.$message.warning("请先在左侧选择学校");
        return;
      }
      this.loadCampusOptions();
      this.dialogTitle = "新增时间段";
      this.editForm = {
        Id: 0,
        SchoolId: getTeacherPatrolCurrentSchoolId(this),
        CampusId: 0,
        SlotName: "",
        StartTime: "12:00:00",
        EndTime: "13:00:00",
        MaxRoundCount: 6,
        SortOrder: 0,
        Enabled: true
      };
      this.editFormVisible = true;
    },
    handleEdit(row) {
      this.loadCampusOptions();
      this.dialogTitle = "编辑时间段";
      this.editForm = {
        ...row,
        CampusId: toDeptId(row.CampusId),
        StartTime: this.formatTime(row.StartTime),
        EndTime: this.formatTime(row.EndTime)
      };
      this.editFormVisible = true;
    },
    editSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return;
        this.editLoading = true;
        try {
          const payload = { ...this.editForm };
          if (!payload.SchoolId) payload.SchoolId = getTeacherPatrolCurrentSchoolId(this);
          const api = payload.Id > 0 ? editTeacherPatrolTimeSlot : addTeacherPatrolTimeSlot;
          const res = await api(payload);
          if (res.data.success) {
            this.$message.success("保存成功");
            this.editFormVisible = false;
            this.getList();
          }
        } finally {
          this.editLoading = false;
        }
      });
    },
    handleDel(row) {
      this.$confirm("确认删除？", "提示", { type: "warning" }).then(async () => {
        const res = await deleteTeacherPatrolTimeSlot(row.Id);
        if (res.data.success) {
          this.$message.success("删除成功");
          this.getList();
        }
      }).catch(() => {});
    },
    normalizeSettingsForm(data) {
      const form = { ...data };
      if (!form.IntervalMinutes || form.IntervalMinutes <= 0) {
        form.IntervalMinutes = 15;
      }
      if (!form.CoveragePercent || form.CoveragePercent <= 0) {
        form.CoveragePercent = 100;
      }
      return form;
    },
    resetSettingsForm() {
      this.settingsForm = {
        SchoolId: 0,
        CampusId: 0,
        IntervalMinutes: 15,
        CoveragePercent: 100
      };
    },
    async loadSettings() {
      if (!this.DepartmentId) {
        this.resetSettingsForm();
        return;
      }
      const res = await getTeacherPatrolSettings({
        departmentId: this.DepartmentId,
        campusId: this.filters.campusId || 0
      });
      if (res.data.success && res.data.response) {
        this.settingsForm = this.normalizeSettingsForm(res.data.response);
      } else {
        this.resetSettingsForm();
      }
    },
    async saveSettings() {
      if (!this.DepartmentId) {
        this.$message.warning("请先选择学校");
        return;
      }
      if (!this.settingsForm.IntervalMinutes || this.settingsForm.IntervalMinutes <= 0
        || !this.settingsForm.CoveragePercent || this.settingsForm.CoveragePercent <= 0) {
        this.$message.warning("请同时配置登记间隔与组内覆盖率");
        return;
      }
      this.settingsSaving = true;
      try {
        const payload = {
          ...this.settingsForm,
          SchoolId: this.settingsForm.SchoolId || getTeacherPatrolCurrentSchoolId(this)
        };
        const res = await saveTeacherPatrolSettings(payload);
        if (res.data.success) {
          this.$message.success("保存成功");
        }
      } finally {
        this.settingsSaving = false;
      }
    }
  }
};
</script>

<style scoped>
.pagination-container { margin-top: 16px; overflow: hidden; }
.field-hint { margin-top: 4px; color: #909399; font-size: 12px; line-height: 1.4; }
.op-cell {
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 4px 0;
}
.op-cell .el-button {
  margin-left: 0;
}
</style>

<style>
/* 操作列留出空间，避免 hover 边框/阴影被表格 cell 裁切 */
.timeslot-op-column .cell {
  overflow: visible;
  padding-top: 6px;
  padding-bottom: 6px;
}
</style>
